import type { UnknownAction } from '@reduxjs/toolkit';

import { resourceStoreTypes, resourceUpserters } from '../core';
import * as actions from './investmentSymbolsActions';
import {
  type InvestmentSymbolProps,
  type InvestmentSymbolsStore,
  INVESTMENT_SYMBOLS_KEY as KEY,
} from './investmentSymbolsTypes';

export const QcsSyncInvestmentSymbolsStoreFactory =
  resourceStoreTypes.createTypedQcsSyncResourceStoreFactory<InvestmentSymbolProps>();

function investmentSymbolsReducer(
  state: InvestmentSymbolsStore = QcsSyncInvestmentSymbolsStoreFactory(),
  action: UnknownAction,
): InvestmentSymbolsStore {
  if (actions.getInvestmentSymbols.match(action)) {
    return state.merge({ isLoading: true });
  }

  if (actions.getInvestmentSymbolsSuccess.match(action)) {
    return resourceUpserters.upsertResources(state, action.payload.set('replaceCollection', false));
  }

  if (actions.getInvestmentSymbolsFailure.match(action)) {
    return resourceUpserters.completeWithError<
      InvestmentSymbolProps,
      resourceStoreTypes.QcsSyncResourceStoreProps<InvestmentSymbolProps>
    >(state, action.payload);
  }

  return state;
}

export const INVESTMENT_SYMBOLS_KEY = KEY;
export default investmentSymbolsReducer;
